import { useEffect, useState } from "react";
import { CalendarDays } from "lucide-react";
import { Calendar } from "./ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { Input } from "./ui/input";

const toUk = (iso) => (iso && /^\d{4}-\d{2}-\d{2}/.test(iso) ? `${iso.slice(8, 10)}/${iso.slice(5, 7)}/${iso.slice(0, 4)}` : "");
const pad = (n) => String(n).padStart(2, "0");
const toIso = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

export function DateField({ value, onChange, disabled, testid, className = "" }) {
  const [text, setText] = useState(toUk(value));
  const [open, setOpen] = useState(false);
  const [bad, setBad] = useState(false);
  useEffect(() => setText(toUk(value)), [value]);
  const commit = (t) => {
    const m = t.trim().match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
    if (!t.trim()) { setBad(false); return onChange(""); }
    const d = m && new Date(Number(m[3]), Number(m[2]) - 1, Number(m[1]));
    if (d && d.getDate() === Number(m[1]) && d.getMonth() === Number(m[2]) - 1) { setBad(false); onChange(toIso(d)); }
    else setBad(true);
  };
  const sel = value ? new Date(`${value.slice(0, 10)}T12:00:00`) : undefined;
  return (
    <div className={`relative ${className}`}>
      <Input disabled={disabled} placeholder="dd/mm/yyyy" value={text} onChange={(e) => setText(e.target.value)} onBlur={(e) => commit(e.target.value)}
        onKeyDown={(e) => e.key === "Enter" && commit(e.currentTarget.value)} className="pr-9" data-testid={testid} />
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <button type="button" disabled={disabled} className="absolute right-2 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground" data-testid={testid ? `${testid}-calendar` : undefined}><CalendarDays className="h-4 w-4" /></button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0" align="end">
          <Calendar mode="single" selected={sel} defaultMonth={sel} weekStartsOn={1} onSelect={(d) => { if (d) { onChange(toIso(d)); setOpen(false); } }} />
        </PopoverContent>
      </Popover>
      {bad && <div className="mt-1 text-xs font-medium text-primary" data-testid={testid ? `${testid}-invalid` : undefined}>Enter a valid date (dd/mm/yyyy)</div>}
    </div>
  );
}
